import { createApi } from "@reduxjs/toolkit/query/react";
import customBaseQuery from "@lxp-app/utils/customBaseQuery";

type OrgRoutes = Record<string, any>;

export const CommonConfigApi = createApi({
  reducerPath: "CommonConfigApi",

  baseQuery: customBaseQuery,

  endpoints: (builder) => ({
    getCommonConfig: builder.query<OrgRoutes, string>({
      query: (key) => ({
        url: `/common-config/${key}`,
        method: "GET"
      }),
      extraOptions: { service: "Utility" }
    }),
    getMultiCommonConfig: builder.mutation({
      query: (body: any) => {
        return {
          url: `/common-config/multi-key-search`,
          method: "POST",
          body
        };
      },
      extraOptions: { service: "Utility" }
    })
  })
});

export const {
  useGetCommonConfigQuery,
  useLazyGetCommonConfigQuery,
  useGetMultiCommonConfigMutation
} = CommonConfigApi;
export default CommonConfigApi;
